import { render, staticRenderFns } from "./SwapConfirmDialog.vue?vue&type=template&id=00a6caf7&"
import script from "./SwapConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SwapConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports